import {
  StyledImage,
  StyledImageWrapper,
  StyledInnerWrapper,
  StyledText,
  StyledTextWrapper,
  StyledVehicleMapDetailWrapper,
  StyledWrapper
} from "./styles";

import { FC } from "react";
import { Icon } from "../../../components";
import { IconButton } from "@mui/material";
import { LeftColumnItemProps } from "./types";
import MapIcon from '@mui/icons-material/Map';

const LeftColumnItem: FC<LeftColumnItemProps> = ({ id, item, isOpened, rows, onItemClick, onVehicleMapDetailClick, onVehicleClick }) => {
  const onClick = () => onVehicleClick(id);

  const handleRedirect = (event: any) => {
    event.stopPropagation();

    window.open(`/#/Vehicle/${id}`, '_blank');
  }

  return (
    <StyledWrapper
      title={item.title + " | " + item.subtitle + " | " + item.convadis}
      clickable={typeof onItemClick === "function"}
      rows={rows}
      onClick={onClick}>
      <StyledInnerWrapper>
        {isOpened ? null : (
          <StyledImageWrapper>
            {item.icon ? (
              <StyledImage src={item.icon} alt="Icon"></StyledImage>
            ) : (
              <Icon iconName="defaultAvatar" />
            )}
          </StyledImageWrapper>
        )}
        <StyledTextWrapper>
          {isOpened ? (
            <StyledText isMain style={{
              width: 55,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis'
            }} onClick={handleRedirect}>{item.title}</StyledText>
          ) : (
            <StyledText isMain onClick={handleRedirect}>{item.title}</StyledText>
          )}
          {isOpened ? null : (
            <StyledText>{item.subtitle}</StyledText>
          )}
          {isOpened ? null : (
            <StyledText>{item.convadis}</StyledText>
          )}
        </StyledTextWrapper>
        {isOpened ? null : (
          <StyledVehicleMapDetailWrapper>
            <IconButton
              size="small"
              onClick={(event: any) =>
                onVehicleMapDetailClick(id)
              }>
              <MapIcon />
            </IconButton>
          </StyledVehicleMapDetailWrapper>
        )}
      </StyledInnerWrapper>
    </StyledWrapper>
  );
};

export default LeftColumnItem;
